// TODO: Refactor each enum into its own file

export enum Salutation {
    DU,
    SIE,
}

export enum ComponentConfigQueue {
    SERVICE = 'service',
    FAKE = 'fake',
}

export enum ChatType {
    BOT_CHAT = 'bot',
    AGENT_CHAT = 'agent',
}

export enum AgentEvent {
    CONNECTED = 'Connected',
    JOIN = 'Join',
    LEAVE = 'Leave',
    SESSION_ACTIVE = 'SessionActive',
    TYPING = 'Typing',
    MESSAGE_RECEIVED = 'MessageReceived',
    CONNECTION_LOST = 'ConnectionLost',
}

export enum SystemMessage {
    CONNECT_TO_AGENT = 'connect_to_agent',
    LOAD_CHAT = 'load_chat',
    LOAD_BOT_ANSWER = 'load_bot_answer',
    LOAD_HISTORY = 'load_history',
}

export enum ErrorTypes {
    INVALID_CHAT_SESSION = 'InvalidChatSessionError',
    INIT_CONNECTION_ERROR = 'InitConnectionError',
}

export enum ClosePageContentType {
    PRINT = 'printContent',
    NO_AGENT_AVAILABLE = 'noAgentAvailableContent',
}

export enum MessageSendState {
    NONE = 'none',
    SEND = 'send',
    RECEIVED = 'received',
    ERROR = 'error',
}

export enum FeedbackState {
    NONE = 'none',
    THUMB_UP = 'thumbUp',
    THUMB_DOWN = 'thumbDown',
    COMPLETED = 'completed',
}

export enum FeedbackReason {
    NOT_UNDERSTOOD = 'not_understood',
    UNCLEAR = 'unclear',
    NOT_HELPFUL = 'not_helpful',
    OTHER = 'other',
}

export enum FeedbackRating {
    THUMB_UP = 'thumb_up',
    THUMB_DOWN = 'thumb_down',
}